import EditorViewState from '../store/schema/EditorViewState';

export default function createEditorViewState(content: string, isDirty: boolean): EditorViewState {
    return {
        content: content,
        isDirty: isDirty,
    };
}
